import {FindPrimersPreferences} from 'constants/PrimerConstants';
import preferences from 'Preferences';

export interface MisprimeOptions {
  minMatchingBases: number | null;
  minMeltingTemp: number | null;
  maxMeltingTemp: number | null;
  maxMismatches: number;
  maxTotalMismatches: number | null;
  exactMatch?: boolean;
  uniqueMatch?: boolean;
}

export function getMisprimeDefaultsFromPreferences(): MisprimeOptions {
  return {
    minMatchingBases: preferences.get(FindPrimersPreferences.MIN_MATCHING_BASES),
    minMeltingTemp: preferences.get(FindPrimersPreferences.MIN_MELTING_TEMP),
    maxMeltingTemp: preferences.get(FindPrimersPreferences.MAX_MELTING_TEMP),
    maxMismatches: preferences.get(FindPrimersPreferences.MAX_MISMATCHES),
    maxTotalMismatches: preferences.get(FindPrimersPreferences.MAX_TOTAL_MISMATCHES),
    exactMatch: preferences.get(FindPrimersPreferences.EXACT_MATCH),
    uniqueMatch: preferences.get(FindPrimersPreferences.UNIQUE_MATCH),
  };
}

export function setMisprimePreferences(misprimeOptions: MisprimeOptions): void {
  const prefs = {
    ...{
      [FindPrimersPreferences.MIN_MATCHING_BASES]: misprimeOptions.minMatchingBases,
      [FindPrimersPreferences.MIN_MELTING_TEMP]: misprimeOptions.minMeltingTemp,
      [FindPrimersPreferences.MAX_MELTING_TEMP]: misprimeOptions.maxMeltingTemp,
      [FindPrimersPreferences.MAX_MISMATCHES]: misprimeOptions.maxMismatches,
      [FindPrimersPreferences.MAX_TOTAL_MISMATCHES]: misprimeOptions.maxTotalMismatches,
    },
    ...(misprimeOptions.exactMatch != null && {
      [FindPrimersPreferences.EXACT_MATCH]: misprimeOptions.exactMatch,
    }),
    ...(misprimeOptions.uniqueMatch != null && {
      [FindPrimersPreferences.UNIQUE_MATCH]: misprimeOptions.uniqueMatch,
    }),
  };

  preferences.set(prefs);
}
